skrilla.controller('csgoDataCtrl', function ($scope, searchService, cacheService, dateService, queryService, srefService, modalService) {
    $scope.key = "csgoData";
    $scope.tabs = [
        {title: "Matches", active: true},
        {title: "Placeholders", active: false},
        {title: "Tournaments", active: false},
        {title: "Franchises", active: false},
        {title: "Players", active: false}
    ];
    $scope.sport = "csgo";
    $scope.seasons = cacheService.getObjectOrElse("csgoSeasons", []);
    cacheService.registerObject("contestSport", $scope.sport);

    $scope.navigateMatches = function(season, match){
        srefService.go($scope.sport + "MatchDetails", {id: match.id});
    }

    $scope.navigatePlaceholders = function(placeholder){
        srefService.go("matchPlaceholderDetails", {id: placeholder.id, sport: $scope.sport});
    }

    $scope.navigateTournaments = function(id){
        srefService.go("tournamentDetails", {id: id, sport: $scope.sport});
    }

    $scope.navigateFranchises = function(franchise){
        srefService.go("franchiseDetails", {id: franchise.id});
    }

    $scope.navigatePlayers = function(id){
        srefService.go("playerDetails", {id: id});
    }

    $scope.createTournament = function() {
        modalService.openModal("views/createTournament/createTournament.html", true, 'lg', true, true);
    }

    $scope.createFranchise = function() {
        modalService.openModal("views/createFranchise/createFranchise.html", true, 'lg', true, true);
    }

    $scope.createPlayer = function() {
        modalService.openModal("views/createPlayerModal/createPlayerModal.html", true, 'lg', true, true);
    }

    $scope.matchDataJob = function(){
        searchService.post("csgo/matches/matchData", {outlookDays: $scope.outlookDays}, "Match Data Job successfully run");
    }

});